/**
 * @generated SignedSource<<5f6d5e40dd9aaf25477f2e0db6041873>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pipelineInternalIdQuery$variables = {
  locator: string;
  skip: boolean;
};
export type pipelineInternalIdQuery$data = {
  readonly pipeline?: {
    readonly internalId: Branded<string, 'ProjectInternalId'> | null | undefined;
  } | null | undefined;
};
export type pipelineInternalIdQuery = {
  response: pipelineInternalIdQuery$data;
  variables: pipelineInternalIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pipelineInternalIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pipelineInternalIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e4440b6695b8a818833257cbd639f491",
    "id": null,
    "metadata": {},
    "name": "pipelineInternalIdQuery",
    "operationKind": "query",
    "text": "query pipelineInternalIdQuery(\n  $locator: String!\n  $skip: Boolean!\n) {\n  pipeline(pipelineLocator: $locator) @skip(if: $skip) {\n    internalId\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f87850e9a2bed850e825b03cc3f341a8";

export default node;
